import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5432a68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ValidationMessage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(" Enter at least "),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.password.length > 0 ? _ctx.validationClasses.min_length : '')
    }, "12 characters", 2 /* CLASS */),
    _createTextVNode(". Include "),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.password.length > 0 ? _ctx.validationClasses.has_lowercase : '')
    }, "one lowercase letter", 2 /* CLASS */),
    _createTextVNode(", "),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.password.length > 0 ? _ctx.validationClasses.has_uppercase : '')
    }, " one uppercase letter", 2 /* CLASS */),
    _createTextVNode(", "),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.password.length > 0 ? _ctx.validationClasses.has_digit : '')
    }, " one number", 2 /* CLASS */),
    _createTextVNode(", and "),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.password.length > 0 ? _ctx.validationClasses.has_special_character : '')
    }, " one special character", 2 /* CLASS */),
    _createTextVNode(". "),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.password.length > 0 ? _ctx.validationClasses.has_no_spaces : '')
    }, " Please do not use any spaces.", 2 /* CLASS */)
  ]))
}